import { useIntl } from '@capsicum/common';

export const useNCWStakeComingSoonDrawer = () => {
	const { $t } = useIntl();

	return {
		intlText: {
			closeButtonText: $t('global.button.close'),
			description1: $t('ncWallet.stake.comingSoon.description1'),
			description2: $t('ncWallet.stake.comingSoon.description2'),
			labelText: $t('ncWallet.stake.comingSoon.labelText'),
			title: $t('ncWallet.stake.comingSoon.title')
		}
	};
};
